import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import Layout from './src/components/Layout';

import './src/css/index.css';

gsap.registerPlugin(ScrollTrigger);

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>;
}

// Adds a shared React Context for Prismic preview sessions.
export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider>{element}</PrismicPreviewProvider>
);

// Function to control the scrolling while routing
export const shouldUpdateScroll = ({ routerProps, getSavedScrollPosition }) => {
  const currentPosition = getSavedScrollPosition(routerProps.location);
  window.scrollTo(...(currentPosition || [0, 0]));

  return false;
};
